import cx from 'classnames';
import { CDN_CLRSAVE_URL } from '../../constants';
import styles from '../../styles/checklist.scss';

export default ({ className = '', items }) => (
  <ul className={cx(styles[className], styles.checklist)}>
    {(items || []).map(point => (
      <li key={point.title} className={styles['checklist-item']}>
        <div className={styles['tick-wrapper']}>
          <img
            src={`${CDN_CLRSAVE_URL}/clearsave/images/block_tick.svg`}
            alt="tick"
          />
        </div>
        <div className={styles.details}>
          <h4 className={styles.title}>{point.title}</h4>
        </div>
      </li>
    ))}
  </ul>
);



// WEBPACK FOOTER //
// ./components/common/checklist.tsx